import { useState, useEffect } from 'react';
import { Grid2 as Grid, Container, Typography } from "@mui/material";
import { useNavigate, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import FormHome from "../../components/home/FormHome";
import { editFiscales } from "../../actions/users";
import { getEstados, getEstadosEEUU } from "../../actions/estados";
import { isEmpty } from '../../components/common/helpers';

import { connect } from 'react-redux';

const MiPerfil = ({ user, isAuthenticated, editFiscales }) => {
  const navigate = useNavigate();
  const [ newRegister, setNewRegister ] = useState({
    email: "",
    ext: "52",
    tel: "",
    razon: "",
    rfc: "",
    regimen: "",
    pais: "",
    estado: "",
    cp: "",
    delegacion: "",
    colonia: "",
    calle: "",
    numExt: "",
    numInt: "",
    terms: false,
    privacy: false,
  });
  const [errors, setErrors] = useState({});
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);

  //Redirect
  if(!isAuthenticated){
    return <Navigate to="/" />
  }

  useEffect(() => {
    (async () => {
      try {
        if(newRegister.pais === "Mexico"){
          const arrEstados = await getEstados();
          setEstados(arrEstados);
        } else if(newRegister.pais === "EEUU") {
          const arrEstados = await getEstadosEEUU();
          setEstados(arrEstados);
        }
      }
      catch (err) {
        console.error("Error: ", err);
      }
    })();
  }, [newRegister.pais]);

  useEffect(() => {
    if(newRegister.pais === "Mexico" && !isEmpty(estados)){
      const index = estados?.findIndex(edo => edo.estado === newRegister.estado);
      setMunicipios(estados[index]?.municipio); 
    }
  }, [newRegister.estado, estados]);

  useEffect(() => {
    if(user){
      setNewRegister({
        ...newRegister,
        email: user.datos_empresas[0]?.email,
        ext: "52",
        tel: user.datos_empresas[0]?.tel,
        razon: user.datos_empresas[0]?.razon_social,
        rfc: user.datos_empresas[0]?.rfc,
        regimen: user.datos_empresas[0]?.regimen_fiscal,
        pais: user.datos_empresas[0]?.direccion_fiscal.pais,
        estado: user.datos_empresas[0]?.direccion_fiscal.estado,
        cp: user.datos_empresas[0]?.direccion_fiscal.cp,
        delegacion: user.datos_empresas[0]?.direccion_fiscal.delegacion,
        colonia: user.datos_empresas[0]?.direccion_fiscal.colonia,
        calle: user.datos_empresas[0]?.direccion_fiscal.calle,
        numExt: user.datos_empresas[0]?.direccion_fiscal.nExt,
        numInt: user.datos_empresas[0]?.direccion_fiscal.nInt,
      });
    }
  }, [user]);

  const handleChange = e => {
    const key = e.target.name;
    const newValue = e.target.value;
    setNewRegister({
      ...newRegister,
      [key]: newValue
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!newRegister.terms || !newRegister.privacy){
      return setErrors({
        errors,
        terms: "Aceptar terminos",
        privacy: "Aceptar politica de privacitad"
      });
    }
    await editFiscales(newRegister, user._id);
    navigate('/detalle-inversiones');
  }

  return (
  <Container component="main" maxWidth="lg">
    <Grid container mt={{ xs: 10, md: 11 }}>
      <Grid container direction="column" alignItems="center" justifyContent="center" mt={5} >
        <Typography variant="h3" component="h2">
          Edición de datos de la empresa inversora
        </Typography>
      </Grid>
      <Grid className="form" size={{ md: 7 }}>
        <FormHome
          errors={errors}
          newRegister={newRegister}
          municipios={municipios}
          estados={estados}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
      </Grid>
    </Grid>
  </Container>
)}

MiPerfil.propTypes = {
  editFiscales: PropTypes.func.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.users.user,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { editFiscales })(MiPerfil);